module.exports = __webpack_public_path__ + "img/favorite-white.bbba29cc.svg";